import { render, staticRenderFns } from "./transferInfo.vue?vue&type=template&id=47ab83de&"
import script from "./transferInfo.vue?vue&type=script&lang=js&"
export * from "./transferInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports